import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AnimatedTextInputWrapper from "components/source/shared/animated-text-input-wrapper";
import { addDays, format, isValid, parseISO } from "date-fns";
import { dateFnsFormats } from "rtr-constants";
import CalendarDrawerModal from "./calendar-drawer/calendar-drawer-modal";

const propTypes = {
  date: PropTypes.string,
  dateInputName: PropTypes.string,
  duration: PropTypes.number,
  durationInputName: PropTypes.string,
  errors: PropTypes.object,
  onOpenModal: PropTypes.func.isRequired,
  updateReservation: PropTypes.func,
  zipCode: PropTypes.string,
  zipInputName: PropTypes.string,
  onChangeReservationInput: PropTypes.func.isRequired,
};

class DateZipInput extends React.Component {
  constructor(props) {
    super(props);
    this.className = "date-zip-input";
  }

  formatDate = date => {
    return format(date, `${dateFnsFormats.dayOfWeekShort} ${dateFnsFormats.M_D}`);
  };

  getFormattedDateZip() {
    const { date, zipCode, duration } = this.props;

    if (!date || !zipCode || !duration) {
      return null;
    }

    const beginDate = parseISO(date);
    if (!isValid(beginDate)) {
      return null;
    }

    const endDate = addDays(beginDate, duration - 1);

    return `${this.formatDate(beginDate)} – ${this.formatDate(endDate)} in ${zipCode}`;
  }

  onZipChange = zip => {
    const { zip_code } = zip;
    this.props.onChangeReservationInput(zip_code, true, this.props.zipInputName);
  };

  renderModal() {
    const { zipCode } = this.props;
    return (
      <CalendarDrawerModal
        onClickSave={this.props.updateReservation}
        onZipSubmit={this.onZipChange}
        zipCode={zipCode}
      />
    );
  }

  render() {
    const { date, duration, zipCode } = this.props;
    const placeholderText = date && !zipCode ? "Enter a Zip Code" : "Choose your rental period";

    return (
      <div className={this.className}>
        <AnimatedTextInputWrapper
          id="hold-date"
          name="dateZipInput"
          type="text"
          error={this.props?.errors?.reservation?.date || this.props?.errors?.reservation?.zipCode}
          label={placeholderText}
          value={this.getFormattedDateZip()}
          readOnly={true}
          onClickCallback={this.props.onOpenModal}
        />
        <input name={this.props.dateInputName || "date"} type="hidden" value={date} />
        <input name={this.props.zipInputName || "zipCode"} type="hidden" value={zipCode} />
        <input name={this.props.durationInputName || "duration"} type="hidden" value={duration} />
        {this.renderModal()}
      </div>
    );
  }
}

DateZipInput.propTypes = propTypes;

export default connect()(DateZipInput);
